/**
 * A ResizeObserver that observes the header element
 * and updates a CSS variable with the header's height.
 */

const header = document.getElementById("header");

if (header) {
	const resizeObserver = new ResizeObserver(([entry]) => {
		const height = entry.contentRect.height;
		document.documentElement.style.setProperty("--header-height", `${height}px`);
	});

	resizeObserver.observe(header);
}
